module.exports = __webpack_public_path__ + "static_portal/img/adult-coach.cb566436.jpg";